import React from "react";
import { Button, Col, Row, Input, Label } from "reactstrap";
import { Redirect, Link } from "react-router-dom";
// import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../../../index.css";
import { TransactionButton } from "./OverviewBank";
import "./formsTable.css";
import "./baseForms.css";

function Reconcile() {
  return (
    <>
      <Row className="Creative-Invoice-header-styling ">
        <Col xs="6" className="card-header-Creative-Invoice">
          <h4 className=" ">Reconcile 'Current Account'</h4>
        </Col>
        <Col xs="6" className="card-header-Creative-Invoice">
          <div className="text-right">
            <Link to="/BackOverView">
              <u className="Back-to-Overview">Back to Bank Account</u>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-chevron-left mx-1 icon-color"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </Link>
          </div>
        </Col>
      </Row>
      <Row className="rowStyling ">
        <div className="row p-4 ">
          <div className="col-md-12">
            <Label>
              "You have no unreconciled bank transactions. Click 'Import
              Statement' to import a file from your bank account and start the
              reconciliation process. "
            </Label>
          </div>

          <hr className="border w-100 " />
          <div className="col-md-12 ">
            <div className="row m-3  Submit-Invoice-btn-div">
              <Button type="submit" className="mr-3 invoiceSubmitButton ">
                Import Statement
              </Button>
            </div>
          </div>
        </div>
      </Row>
    </>
  );
}
export default Reconcile;
